var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ChevronIcon = function (_a) {
    var className = _a.className, fill = _a.fill;
    return (_jsxs("svg", __assign({ width: "21", height: "20", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_4908_1065)" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.2071 7.29289C15.5976 7.68342 15.5976 8.31658 15.2071 8.70711L11.2071 12.7071C10.8166 13.0976 10.1834 13.0976 9.79289 12.7071L5.79289 8.70711C5.40237 8.31658 5.40237 7.68342 5.79289 7.29289C6.18342 6.90237 6.81658 6.90237 7.20711 7.29289L10.5 10.5858L13.7929 7.29289C14.1834 6.90237 14.8166 6.90237 15.2071 7.29289Z", fill: fill || '#6F7276' }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_4908_1065" }, { children: _jsx("rect", { width: "20", height: "20", fill: "white", transform: "translate(0.5)" }) })) })] })));
};
